import BaseService from '@/services/BaseService';
export type TriggersAndCovenantsColumnMeta = {
  field: string;
  dataType: string;
};

export type TriggersAndCovenantsAssetClassTable =
  | 'DV01_ASSET_CLASS_AUTO'
  | 'DV01_ASSET_CLASS_CREDIT_CARD'
  | 'DV01_ASSET_CLASS_CONSUMER_UNSECURED'
  | 'DV01_ASSET_CLASS_ENERGY_RESIDENTIAL'
  | 'DV01_ASSET_CLASS_ENERGY_C_I'
  | 'DV01_ASSET_CLASS_STUDENT_LOANS'
  | (string & {});

export type TriggersAndCovenantsRequestConfig = {
  assetClassTable?: TriggersAndCovenantsAssetClassTable;
  /** Overrides segment derived from {@link assetClassTable}. */
  triggersPathOverride?: string;
  /** When set, column + row requests use this resource instead of `triggers-covenants/{segment}`. */
  triggersResourcePath?: string;
};

const ASSET_CLASS_PATH: Record<string, string> = {
  DV01_ASSET_CLASS_AUTO: 'auto',
  DV01_ASSET_CLASS_CREDIT_CARD: 'credit-card',
  DV01_ASSET_CLASS_CONSUMER_UNSECURED: 'consumer-unsecured-non-marketplace',
  DV01_ASSET_CLASS_ENERGY_RESIDENTIAL: 'energy',
  DV01_ASSET_CLASS_ENERGY_C_I: 'energy-ci',
  DV01_ASSET_CLASS_STUDENT_LOANS: 'student-loan',
};

function resolvePathSegment(config: TriggersAndCovenantsRequestConfig): string {
  return config.triggersPathOverride ?? ASSET_CLASS_PATH[config.assetClassTable ?? ''] ?? 'auto';
}

/** HTTP client for pivoted triggers & covenants column metadata and SSRM grids. */
export class TriggersAndCovenantsService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  resolveColumnsPath = (config: TriggersAndCovenantsRequestConfig = {}): string => {
    if (config.triggersResourcePath) {
      return `${config.triggersResourcePath}/columns`;
    }
    const segment = resolvePathSegment(config);
    return `triggers-covenants/${segment}/columns`;
  };

  resolveSsrmEndpoint = (config: TriggersAndCovenantsRequestConfig = {}): string => {
    if (config.triggersResourcePath) {
      return config.triggersResourcePath;
    }
    const segment = resolvePathSegment(config);
    return `triggers-covenants/${segment}`;
  };

  fetchColumns = async (config: TriggersAndCovenantsRequestConfig = {}): Promise<TriggersAndCovenantsColumnMeta[]> => {
    const response = await this.get({ path: this.resolveColumnsPath(config) });
    return Array.isArray(response) ? response : [];
  };
}
